import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { changeStaffBusinessUnits } from '@containers/Admin/containers/StaffPage/actions';
import { BusinessUnitMultiSelect } from '@containers/Admin/shared/BusinessUnitMultiSelect';

interface SelectBusinessUnitsProps {
  canEditBusinessUnits: boolean;
}

export const SelectBusinessUnits = ({ canEditBusinessUnits }: SelectBusinessUnitsProps) => {
  const dispatch = useDispatch();
  const {
    allBusinessUnits,
    userData: { id, businessUnits = [], businessUnitsInfo = [] },
  } = useSelector((state: RootStateOrAny) => state.get('staffPage').toJS()); // FIXME replace to typing store

  const displayBusinessUnits = canEditBusinessUnits
    ? allBusinessUnits
    : businessUnitsInfo;

  return (
    <BusinessUnitMultiSelect
      canEditBusinessUnits={canEditBusinessUnits}
      allBusinessUnits={displayBusinessUnits}
      selectedBusinessUnits={businessUnits}
      onChangeBusinessUnits={(nextSelectedBusinessUnits) => {
        dispatch(changeStaffBusinessUnits(nextSelectedBusinessUnits, id));
      }}
    />
  );
};